__turbopack_context__.v({
  "wrapper": "yXhuSW_wrapper",
});
